import { Pipe, PipeTransform } from '@angular/core';
import moment, * as momentClass from 'moment';
// This is maintly just to satisfy Jest
import {
    browserTimezone,
    DateFormatService
} from '@flyfreely-portal-ui/flyfreely';
import {
    CurrentOrganisation,
    WorkspaceStateService
} from '@flyfreely-portal-ui/workspace';

@Pipe({ name: 'formatDateTime', pure: false })
export class FormatDateTimePipe implements PipeTransform {
    constructor(
        private dateFormatService: DateFormatService,
        private workspaceStateService: WorkspaceStateService
    ) {}
    transform(
        dateTimeStr: string | Date | moment.Moment,
        timeZone?: string,
        suppressTimeZone = false
    ): string | null {
        if (!dateTimeStr) {
            return null;
        }
        // Use the time zone passed in. Falling back on the organisation, then the browser time zones.
        // As a final fallback have moment guess, though this will usually also return the browser or system time.
        const timeZoneToUse =
            timeZone != null
                ? timeZone
                : this.workspaceStateService.getCurrentOrganisation().type ===
                  'organisation_loaded'
                ? (<CurrentOrganisation>(
                      this.workspaceStateService.getCurrentOrganisation()
                  )).organisation.timeZone
                : browserTimezone ?? moment.tz.guess();

        const format = this.dateFormatService.getDateTimeFormat();

        if (momentClass.isMoment(dateTimeStr)) {
            return moment(dateTimeStr).format(`${format} z`);
        }

        if (timeZone != null) {
            const formatWithSuppress = suppressTimeZone
                ? format
                : `${format} z`;
            return moment(dateTimeStr)
                .tz(timeZoneToUse)
                .format(formatWithSuppress);
        }

        return moment(dateTimeStr).tz(timeZoneToUse).format(format);
    }
}
